export default __webpack_public_path__ + "static/media/blog-img88.22c4a290.jpg";